import styled from 'styled-components';
import { device } from 'modules/Utils/Devices';
import { ZIndexes } from 'modules/Utils/ZIndexes';

export const Container = styled.div`
  padding: 4rem 0;
`;

export const GalleryContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: ${(props) =>
    props.secondary
      ? '0'
      : `${props.theme.config.spacing.spacing_4} ${props.theme.config.spacing.spacing_4}`};

  .image-gallery {
    margin-right: 24px;
  }

  @media ${device.tabletMin} {
    .image-gallery {
      min-width: 60rem;
      max-width: 60rem;
    }
  }

  .image-gallery.fullscreen-modal {
    min-width: 100%;
    z-index: ${ZIndexes.fullscreen};
  }

  .image-gallery-thumbnails-container {
    cursor: default;
    text-align: left;
  }

  .image-gallery-fullscreen-button {
    top: 0;
    bottom: unset;
  }

  @media ${device.tabletAndMobile} {
    flex-direction: column;

    .image-gallery {
      margin-right: 0px;
      margin-bottom: 24px;
    }
  }

  .image-gallery-right-nav,
  .image-gallery-left-nav {
    top: 390px;
  }
`;
